export default "__VITE_ASSET__09f6069e__"